export default "__VITE_ASSET__D55KdYqT__"